import cookie from 'cookie';
import consolv from 'lib/consolv';

const defaults = {
	liveRampPixel: {
		enabled: false,
	},
};

/**
 * Appends a LiveRamp pixels to the page once per day
 */

const frequency = 86400000; // One day

export function appendPixel(localStorageKey, pixelUrl) {
	const localStorageValue = window.localStorage.getItem(localStorageKey);
	if (localStorageValue && localStorageValue > new Date().getTime()) return;

	consolv.log('MCP: Appending LiveRamp Pixel', localStorageKey);
	const image = document.createElement('img');
	// border='0' hspace='0' vspace='0' width='1' height='1'
	image.id = localStorageKey;
	image.src = pixelUrl;
	image.style.position = 'absolute';
	image.style.opacity = 0;
	document.body.appendChild(image);

	window.localStorage.setItem(localStorageKey, new Date().getTime() + frequency);
}

export function appendLiveRampPixels(MCP) {
	try {
		const { liveRampPixel } = MCP.Configurator.getConfiguration({ defaults });

		if (!liveRampPixel.enabled === true || !window.localStorage) return;

		consolv.log('MCP: LiveRamp Pixel Module loaded');

		const cookies = cookie.parse(window.document.cookie);
		const partnerId = cookies.datid || cookies.WMUKID_STABLE;

		if (partnerId) {
			appendPixel('dat-liveramp-gam',
				`https://idsync.rlcdn.com/712551.gif?partner_uid=${partnerId}`);
		}

// 		const freewheelId = cookies.bea4;
// 		if (freewheelId) {
// 			appendPixel('dat-liveramp-fw',
// 				`https://idsync.rlcdn.com/712348.gif?partner_uid=${freewheelId}`);
// 		}
	} catch (e) {
		consolv.log('MCP: Problem appending LiveRamp Pixel', e);
	}
}

export default function setupLiveRampPixels(MCP) {
	MCP.addEventListener('initialized', () => { appendLiveRampPixels(MCP); });
}
